import {
  photoURL,isSignIn,email,displayName,
  access_token,
  access_token_exp,
  user_id,
  roles,
  updateByToken,
  CLEAR,
} from './mutation-types';

export default {
  [photoURL] (state,
    photoURL
  ) {
    state['photoURL'] = photoURL;
  },
  [isSignIn] (state,
    isSignIn
  ) {
    state['isSignIn'] = isSignIn;
  },
  [email] (state,
    email
  ) {
    state['email'] = email;
  },
  [displayName] (state,
    displayName
  ) {
    state['displayName'] = displayName;
  },
  //[isAdmin] (state,
    //isAdmin
  //) {
    //state['isAdmin'] = isAdmin;
  //},
  [access_token] (state,
    access_token
  ) {
    state['access_token'] = access_token;
  },
  [access_token_exp] (state,
    access_token_exp
  ) {
    state['access_token_exp'] = access_token_exp;
  },
  [user_id] (state,
    user_id
  ) {
    state['user_id'] = user_id;
  },
  [roles] (state,
    roles
  ) {
    state['roles'] = roles;
  },
  [updateByToken] (state, {access_token, decoded}) {
    state['isSignIn'] = true;
    state['access_token'] = access_token;
    state['access_token_exp'] = decoded.exp;
    state['displayName'] = decoded.username;
    state['user_id'] = decoded.sub;
    state['roles'] = decoded.roles;
    state['orgId'] = decoded.orgId;
    state['orgName'] = decoded.org;
  },
  [CLEAR] (state) {
      state['isSignIn'] = false;
      state['access_token'] = '';
      state['access_token_exp'] = 0;
      state['displayName'] = '';
      state['user_id'] = 0;
      state['roles'] = '';
      state['orgId'] = 0;
      state['orgName'] = '';
  },
}
